import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { LangChangeEvent, TranslateModule, TranslateService } from '@ngx-translate/core';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { Subscription } from 'rxjs';
import { InfoBoxComponent } from '../../utility/info-box/info-box.component';
import { CommonModule } from '@angular/common';
import { AppointmentStepperService } from '../../../services/appointment-stepper.service';

@Component({
  selector: 'app-specialist-selection',
  standalone: true,
  imports: [CommonModule, NzDividerModule, NzRadioModule, ReactiveFormsModule, TranslateModule, InfoBoxComponent],
  templateUrl: './specialist-selection.component.html',
  styleUrl: './specialist-selection.component.scss',
})
export class SpecialistSelectionComponent implements OnInit, OnDestroy {
  @Output() specialistEmitter: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
  radioForm?: FormGroup;
  subscriptions: Array<Subscription> = [];
  specialistSelection?: any = [
    ['Cardiologo', 'Endocrinologo', 'Diabetologo', 'Reumatologo', 'Geriatra'],
    ['Ginecologo', 'Senologo', 'Ostetrico', 'Otorinolaringoiatra', 'Ortopedico'],
    ['Neurologo', 'Psichiatra', 'Neuropsicologo'],
    ['Pediatra', 'Neuropsicomotricista'],
    ['Logopedista', 'Medico dello sport', 'Nutrizionista'],
  ];
  radioTitles!: [];
  radioLabels!: [];

  constructor(
    private fb: FormBuilder,
    private translateService: TranslateService,
    private appointmentStepperService: AppointmentStepperService
  ) {}

  public ngOnInit(): void {
    this.radioForm = this.fb.group({});
    this.specialistSelection.forEach((element: any, index: any): void => {
      this.radioForm?.addControl('specialistType', new FormControl('', Validators.required));
    });
    this.emitSpecialistForm();
    this.subscriptions.push(
      this.translateService.onLangChange.subscribe((_: LangChangeEvent): void => {
        this.getTexts();
      })
    );
    this.getTexts();
    const oldValues = this.appointmentStepperService.getSpecialistData();
    if (oldValues) {
      this.radioForm.patchValue(oldValues.value);
    }
  }

  private getTexts(): void {
    this.translateService.get('steps.specialistSelection.specialtyElements').subscribe((radioLabels: any): void => {
      this.radioLabels = radioLabels;
    });
    this.translateService.get('steps.specialistSelection.titlesRadioButtons').subscribe((radioTitles: any): void => {
      this.radioTitles = radioTitles;
    });
  }

  private emitSpecialistForm(): void {
    if (this.radioForm) {
      this.subscriptions.push(
        this.radioForm.valueChanges.subscribe((_): void => {
          this.specialistEmitter.emit(this.radioForm);
        })
      );
    }
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription): void => {
      subscription.unsubscribe();
    });
  }
}
